enum TableauTool {
  Pause = 'pause',
  Revert = 'revert',
  Refresh = 'refresh',
  Export = 'export',
  Undo = 'undo',
  Redo = 'redo',
  Maximize = 'maximize',
  Views = 'views'
}

export default TableauTool;
